export default __webpack_public_path__ + "static/media/Arch_AWS-Backup_16.3d5fe543.svg";